<template>
<section class="summary-history">
    <div class="card">
      <div class="card-header">
        <i class="fa fa-history"></i> {{$t('checklist.attribute.history_summary')}} checklist <b>"{{checklist.name}}"</b>
        <div class="card-actions" v-permission = "$permissions.CREATE_CHECKLIST">
          <router-link to='../view' style="cursor: pointer">
            <small class="text-muted">
              <i class="fa fa-arrow-left"></i></small>
          </router-link>
      </div>
      </div>
      <div class="card-body">
        <table class="table table-hover">
          <thead class="thead-light">
            <tr>
              <th>{{$t('summary.author')}}</th>
              <th>{{$t('summary.total_result')}}</th>
              <th>{{$t('summary.created_at')}}</th>
              <th>{{$t('summary.action')}}</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(summary, key) in summaries" :key="key">
              <td>{{summary.user ? summary.user.fullname : ''}}</td>
              <td>{{summary.total_result}}</td>
              <td>{{summary.created_at}}</td>
              <td>
                <button class="btn-sm btn-warning btn" @click="viewSummary(summary)"> <i class="fa fa-eye"></i> </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </section>

</template>
<script>
export default {
  name: 'summary-history',
  components: {},
  props: [],
  data () {
    return {
      summaries: [],
      checklist: {}
    }
  },
  computed: {

  },
  mounted () {
    Promise.all([
      this.$store.dispatch('Summary/getAllSummary', {checklist: {id: this.$route.params.checklist_id}}),
      this.$store.dispatch('Checklist/showChecklist', {checklist: {id: this.$route.params.checklist_id}})
    ]).then(res => {
      this.summaries = res[0]
      this.checklist = res[1]
    }).catch(errors => {

    })
  },
  methods: {
    viewSummary (summary) {
      this.$router.push('' + summary.id)
    }
  }
}

</script>
<style lang="scss"></style>



// WEBPACK FOOTER //
// src/views/checklist/view/summary-history/list.vue